module.exports = __webpack_public_path__ + "static/top-defaa1559f7f97904ede6747c8ad6f40.png";